import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import './index.css';
import Quiz from './Quiz';
import FocusMode from './FocusMode';
import Journal from './Journal';
import BlogPost from './BlogPost';

function App() {
  const location = useLocation();

  const isQuiz = location.pathname === '/personalized-prompt';
  const isJournal = location.pathname.startsWith('/journal');
  const isFocus = location.pathname === '/' || location.pathname.startsWith('/prompts/');

  return (
    <>
      <div className="ambient-bg">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </div>

      <header className="site-header">
        <div className="header-inner">
          <Link to="/" className="logo">
            <img src="/logo.png" alt="Mindful Journal Prompts" className="logo-img" />
            <span className="logo-text">Mindful Journal Prompts</span>
          </Link>
          <nav className="header-nav">
            <Link to="/" className={`nav-link ${isFocus ? 'active' : ''}`}>Focus</Link>
            <Link to="/personalized-prompt" className={`nav-link ${isQuiz ? 'active' : ''}`}>Personalized Prompt</Link>
            <Link to="/journal" className={`nav-link ${isJournal ? 'active' : ''}`}>Insightful Articles</Link>
          </nav>
        </div>
      </header>

      <div className="layout-wrapper">
        <div className={`main-column${isJournal ? ' main-column-wide' : ''}`}>
          <main>
            <Routes>
              <Route path="/" element={<FocusMode />} />
              <Route path="/prompts/:topic" element={<FocusMode />} />
              <Route path="/personalized-prompt" element={<Quiz />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:slug" element={<BlogPost />} />
            </Routes>
          </main>
        </div>
      </div>

      <footer className="site-footer">
        <p>This site is for educational purposes only. If you are experiencing a mental health emergency, please contact your local mental health counsellor or emergency services.</p>
      </footer>
    </>
  );
}

export default App;
